<template>
  <div>
    <div class="icoCalendar"></div>
    <div class="slimButton" :class="{ error }" @click="open">
      Time ({{ value.length }})
    </div>

    <Modal ref="modalRef" title="Campaigns - Time" width="850px">
      <div class="timePlaceModal" :class="{ disabled: readOnly }">
        <div class="timePlaceModal__column first">
          <div class="timePlaceModal__column__firstRow"></div>
          <div
            class="timePlaceModal__column__row time pointer"
            v-for="(dayPart, dayPartIndex) in activeGame.partsPerDay"
            :key="`TimePart-${dayPartIndex}`"
            @click="toggleDayPart(dayPartIndex)"
          >
            {{ dayPart | dayPart }}
          </div>
        </div>

        <div
          class="timePlaceModal__column"
          v-for="(day, dayIndex) in activeGame.daysPerTurn"
          :key="`DayPart-${dayIndex}`"
        >
          <div
            class="timePlaceModal__column__firstRow pointer"
            @click="toggleDay(dayIndex)"
          >
            {{ day }}
          </div>
          <div
            class="timePlaceModal__column__row"
            v-for="(hour, hourIndex) in activeGame.partsPerDay"
            :key="`Hour-${hourIndex}`"
          >
            <label class="container">
              <input
                type="checkbox"
                :id="day.name + '-' + hour.time"
                :value="
                  hourIndex + 1 + dayIndex * activeGame.partsPerDay.length
                "
                v-model="localValue"
                :disabled="readOnly"
              />
              <span class="checkmark"></span>
            </label>
          </div>
        </div>

        <div class="timePlaceModal__selectedNumber">
          Selected <span class="number">{{ localValue.length }}</span>
          <span v-if="localValue.length > 1 || localValue.length === 0"
            >times</span
          ><span v-else>time</span>
        </div>

        <div class="timePlaceModal__confirm" @click="confirm">Confirm</div>
      </div>
    </Modal>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import Modal from "@/components/general/Modal.vue";
import ModalJs from "@/components/general/ModalJs.js";

export default {
  name: "TimeButton",
  mixins: [ModalJs],
  components: {
    Modal,
  },
  filters: {
    dayPart: (value) => {
      const parts = value.split("-");
      return parts.length > 1 ? `${parts[0]} - ${parts[1]}` : value;
    },
  },
  props: {
    readOnly: Boolean,
    value: Array,
    error: Boolean,
  },
  data() {
    return {
      localValue: this.value || [],
    };
  },
  computed: {
    ...mapGetters(["activeGame"]),
  },
  watch: {
    value(value) {
      if (value !== this.localValue) {
        this.localValue = value || [];
      }
    },
  },
  methods: {
    confirm() {
      this.$emit("input", this.localValue);
      this.closeModal();
    },
    open() {
      this.localValue = this.value;
      this.openModal();
    },
    toggleDay(day) {
      const partsLength = this.activeGame.partsPerDay.length;
      const from = day * partsLength;
      const dayValues = Array.from(
        { length: partsLength },
        (v, k) => k + from + 1
      );
      this.toggleValue(dayValues);
    },
    toggleDayPart(dayPart) {
      const dayPartValues = [];
      const partsLength = this.activeGame.partsPerDay.length;
      const daysLength = this.activeGame.daysPerTurn.length;
      for (let i = 0; i < daysLength; i++) {
        dayPartValues.push(dayPart + 1 + partsLength * i);
      }
      this.toggleValue(dayPartValues);
    },
    toggleValue(data) {
      const difference = _.difference(data, this.localValue);
      this.localValue = difference.length
        ? _.concat(difference, this.localValue)
        : _.difference(this.localValue, data);
    },
  },
};
</script>
